import { PolicyType } from '@practium/features/policy';
import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export interface PolicyVersionResponse {
    _id: string;
    versionNumber: string;
    content: string;
    effectiveDate: string;
    isActive: boolean;
    policyType: PolicyType;
    title?: string;
    description?: string;
    updatedAt: string;
}

export function useGetPolicies() {
    const query = useQuery<PolicyVersionResponse[]>({
        queryKey: ['policies', 'active'],
        queryFn: async () => {
            try {
                const response = await api.get<PolicyVersionResponse[]>('/policy-version/findAll');
                return response.data;
            } catch (error) {
                throw toApiError(error, 'Erro ao buscar políticas');
            }
        },
    });

    return {
        ...query,
    };
}
